import React from "react";
import { FaSearch } from "react-icons/fa";
import { SearchSliderOpen, SearchSliderDrawer, WMKLink } from "wmk-lib";
import Theme, { buildLinkPath } from "../../../../vars/ThemeOptions";
import styled from "styled-components";

const Styled = {};
Styled.Search = styled.div`
  .wmk-search-drawer {
    background: ${Theme.hex("concrete")};
  }
  .close {
    font-size: 3rem;
    @media screen {
      :focus {
        outline: none;
      }
    }
  }
  .results .col {
    -webkit-flex: initial;
    display: flex;
    align-items: flex-start;
    font-size: 1.25rem;
    flex-direction: column;
    .wmk-link {
      color: ${Theme.hex("blue")};
      text-decoration: none;
      :hover {
        color: ${Theme.hex("green")};
      }
    }
  }
  .form-control {
    appearance: none;
    border: none;
    border-bottom: 2px solid gray;
    border-radius: 0;
    background: none;
    font-size: 1.5rem;
    :focus {
      outline: none;
      box-shadow: none;
    }
  }
`;

const Search = ({ isMobile, isSearchOpen, setIsSearchOpen, query }) => {
  return (
    <Styled.Search>
      <SearchSliderOpen
        isSearchOpen={isSearchOpen}
        setIsSearchOpen={setIsSearchOpen}
      >
        <div>
          <FaSearch />
        </div>
        {isMobile ? <span>Search</span> : null}
      </SearchSliderOpen>
      <SearchSliderDrawer
        isSearchOpen={isSearchOpen}
        setIsSearchOpen={setIsSearchOpen}
        query={query}
        Result={({ result }) => (
          <WMKLink to={buildLinkPath(result)}>{result.title}</WMKLink>
        )}
        useAlgorithm={(event, index) => {
          let search = index.filter((item) => {
            const { modules } = item;
            const moduleTitles = modules
              ? modules.map((module) => {
                //console.log(module)
                  return module.title.toLowerCase();
                })
              : [];
            const title = item.title.toLowerCase();
            const target = event.target.value.toLowerCase();
            const inModTitles = moduleTitles.map((modTitle) => {
              return modTitle.includes(target);
            });
            return title.includes(target) || inModTitles.find((found) => found);
          });
          return { key: event.target.value, results: search };
        }}
      />
    </Styled.Search>
  );
};

export default Search;
